var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.showModal
      ? _c("div", { staticClass: "modal" }, [
          _c("button", {
            staticClass: "modal__overlay js-modal-close",
            on: { click: _vm.closeModal },
          }),
          _c("div", { staticClass: "modal__content trs" }, [
            _c(
              "div",
              {
                staticClass: "modal__close-btn",
                on: { click: _vm.closeModal },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "icon-btn t-tdn trs  js-modal-close",
                    attrs: {
                      onclick: "",
                      "data-product-id": "",
                      type: "button",
                    },
                  },
                  [
                    _vm._v("Закрыть модальное окно"),
                    _c("span", { staticClass: "media-obj" }, [
                      _c(
                        "svg",
                        { attrs: { xmlns: "http://www.w3.org/2000/svg" } },
                        [
                          _c("use", {
                            attrs: {
                              href: "/local/templates/renaissance/layout/dist/assets/img/sprite.svg#i-close",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _c("div", { staticClass: "modal__inner bg-white" }, [
              _c("div", { staticClass: "modal__wrapper" }, [
                _vm.productTitle
                  ? _c("h2", { staticClass: "modal__title t-h2 clr-blue-7" }, [
                      _vm._v("Запрос стоимости: " + _vm._s(_vm.productTitle)),
                    ])
                  : _vm._e(),
                !_vm.productTitle
                  ? _c("h2", { staticClass: "modal__title t-h2 clr-blue-7" }, [
                      _vm._v(_vm._s(_vm.title)),
                    ])
                  : _vm._e(),
                !_vm.isSuccess
                  ? _c(
                      "form",
                      {
                        staticClass: "js-form modal__form",
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.formSubmit.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm._l(_vm.fields, function (item) {
                          return _c(_vm.getComponentByType(item.component), {
                            key: item.id,
                            tag: "component",
                            attrs: { item: item },
                            model: {
                              value: _vm.updateField,
                              callback: function ($$v) {
                                _vm.updateField = $$v
                              },
                              expression: "updateField",
                            },
                          })
                        }),
                        _c(
                          "button",
                          {
                            staticClass:
                              "modal__submit btn btn--outline btn-submit clr-blue-10",
                            class: { active: _vm.isSuccess },
                            attrs: {
                              type: "submit",
                              "data-text": "",
                              submit: "",
                            },
                          },
                          [_vm._v(_vm._s(_vm.sendText))]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "input field modal__input--privacy-check",
                          },
                          [
                            _c("input", {
                              staticClass: "input__el clr-blue-22 trs",
                              attrs: { type: "checkbox", checked: "true" },
                            }),
                            _c("label", { staticClass: "input__label" }, [
                              _vm._v(
                                "Отправляя заявку, я подтверждаю, что ознакомлен и согласен с Политикой конфиденциальности данного сайта"
                              ),
                            ]),
                          ]
                        ),
                        _vm.errors.length
                          ? _c("div", { staticClass: "form-error" }, [
                              _vm._v(_vm._s(_vm.error)),
                            ])
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.isSuccess
                  ? _c("div", { staticClass: "success-message" }, [
                      _vm._v("Отправлено!"),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }